// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px;
  margin: 0 auto;
  max-width: 100%;
}

.calendar-cell {
  min-height: 60px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
  transition: 0.2s ease-in-out;
  cursor: pointer;
  padding: 10px 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  word-break: break-word;
}

.calendar-cell:hover {
  background-color: #e3f2fd;
}

.calendar-header {
  background-color: #f1f1f1;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 13px;
  cursor: default;
}

.present-day {
  background-color: #d0f0c0;
  border-color: #8bc34a;
}

.absent-day {
  background-color: #ffcdd2;
  border-color: #e57373;
}

.leave-day {
  background-color: #fff9c4;
  border-color: #fbc02d;
}

.empty-cell {
  background: transparent;
  border: none;
  cursor: default;
}

.day-number {
  font-weight: 600;
  font-size: 16px;
}

/* ✅ Responsive tweaks */
@media (max-width: 768px) {
  .calendar-cell {
    font-size: 12px;
    padding: 8px 4px;
    min-height: 45px;
  }
  .day-number {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .calendar-grid {
    grid-template-columns: repeat(7, minmax(36px, 1fr));
    gap: 4px;
  }
  .calendar-cell {
    padding: 6px 2px;
    min-height: 40px;
    font-size: 11px;
  }
  .calendar-header {
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/AdminComponents/Calendar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mDAAmD;IACnD,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".calendar-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  gap: 6px;\r\n  margin: 0 auto;\r\n  max-width: 100%;\r\n}\r\n\r\n.calendar-cell {\r\n  min-height: 60px;\r\n  background-color: #f8f9fa;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  transition: 0.2s ease-in-out;\r\n  cursor: pointer;\r\n  padding: 10px 5px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  word-break: break-word;\r\n}\r\n\r\n.calendar-cell:hover {\r\n  background-color: #e3f2fd;\r\n}\r\n\r\n.calendar-header {\r\n  background-color: #f1f1f1;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  font-size: 13px;\r\n  cursor: default;\r\n}\r\n\r\n.present-day {\r\n  background-color: #d0f0c0;\r\n  border-color: #8bc34a;\r\n}\r\n\r\n.absent-day {\r\n  background-color: #ffcdd2;\r\n  border-color: #e57373;\r\n}\r\n\r\n.leave-day {\r\n  background-color: #fff9c4;\r\n  border-color: #fbc02d;\r\n}\r\n\r\n.empty-cell {\r\n  background: transparent;\r\n  border: none;\r\n  cursor: default;\r\n}\r\n\r\n.day-number {\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n}\r\n\r\n/* ✅ Responsive tweaks */\r\n@media (max-width: 768px) {\r\n  .calendar-cell {\r\n    font-size: 12px;\r\n    padding: 8px 4px;\r\n    min-height: 45px;\r\n  }\r\n  .day-number {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .calendar-grid {\r\n    grid-template-columns: repeat(7, minmax(36px, 1fr));\r\n    gap: 4px;\r\n  }\r\n  .calendar-cell {\r\n    padding: 6px 2px;\r\n    min-height: 40px;\r\n    font-size: 11px;\r\n  }\r\n  .calendar-header {\r\n    font-size: 11px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
